import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IOption } from '../../../models/ICommon';
import { IBaseAIMSDetails } from '../../../models/response/IAimsResponse';
import { formatMessage } from '../../../translations/format-message';
import AIMSPortalForm from '../forms/add-edit-aims-portal-form';

interface IProps {
  templates: IOption[];
}

const AddAIMSPortal = (props: IProps) => {
  const { aimsPortalStore } = useStore();
  const {
    AddPortalService,
    resetAddUpdatePortalState,
    addUpdatePortalState,
    getAimsDetails,
  } = aimsPortalStore;
  const initialValues: IBaseAIMSDetails = getAimsDetails;

  useEffect(() => {
    if (addUpdatePortalState.success) {
      toast.success(formatMessage('added_success'));
    }
  }, [addUpdatePortalState.success]);

  useEffect(() => {
    if (addUpdatePortalState.error) {
      toast.error(formatMessage(addUpdatePortalState.error));
      resetAddUpdatePortalState();
    }
  }, [addUpdatePortalState.error]);

  const onSubmitForm = ({
    NearDeadlineTemplateId,
    DeadlineCrossTemplateId,
    RegularModeTemplateId,
    PatternForMissingPartTemplateId,

    NearDeadlineProTemplateId,
    DeadlineCrossProTemplateId,
    RegularModeProTemplateId,
    PatternForMissingPartProTemplateId,

    NearDeadLineDate,
    StationCode,
    Url,
  }: IBaseAIMSDetails) => {
    var addObj: IBaseAIMSDetails = {
      NearDeadlineTemplateId,
      DeadlineCrossTemplateId,
      RegularModeTemplateId,
      NearDeadlineProTemplateId,
      DeadlineCrossProTemplateId,
      RegularModeProTemplateId,
      NearDeadLineDate: NearDeadLineDate,
      PatternForMissingPartTemplateId: '-1',
      PatternForMissingPartProTemplateId: '-1',
      TenantId: Number(getTenantIdFromLocalStorage()),
      StationCode,
      Url,
    };
    AddPortalService(addObj);
  };

  return (
    <React.Fragment>
      <AIMSPortalForm
        initialValues={initialValues}
        submitHandler={onSubmitForm}
        templateOptions={props.templates}
        isLoading={addUpdatePortalState.inProgress}
      />
    </React.Fragment>
  );
};

export default observer(AddAIMSPortal);
